<script setup>
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { usePlaylistStore } from '@/stores/playlist.js'
import ButtonTriggerModal from '@/Pages/Playlist/components/Misc/ButtonTriggerModal.vue'
const page = usePage()
const plStore = usePlaylistStore()

const props = defineProps({
    row: {
        type: Object,
        default: undefined,
    },
    cardIndex: {
        type: Number,
        default: undefined,
    },
    brand: {
        type: Object,
        default: undefined,
    },
    scormExport: Boolean,
})

const themeContent = computed(() => plStore.cards?.[props.cardIndex]?.theme?.content ?? {})

const headingFont = computed(() => {
    const font = themeContent.value.heading_font || themeContent.value.font
    return font ? font.replace(/_/g, ' ') : ''
})

const bodyFont = computed(() => {
    const font = themeContent.value.font
    return font ? font.replace(/_/g, ' ') : ''
})

const imgPath = (button) => {
    if (props.scormExport) {
        return button.buttonImage;
    }
    return 'https://' + page.props.s3_bucket + '.s3.' + page.props.s3_region + '.amazonaws.com' + button.buttonImage
};
</script>
<template>
    <div class="w-full grid grid-cols-2 gap-4 p-fl-4" @click="openEditorPanel">
        <ButtonTriggerModal
            v-for="(button, index) in row.content.buttons"
            :key="index"
            :button-text="button.buttonText"
            :modal-title="button.popupTitle"
            :illustration-width="button.buttonImageWidth"
            :illustration="imgPath(button)"
            :modal-body="button.popupContent"
            :brand="brand"
            :heading-font="headingFont"
            :body-font="bodyFont"
        />
    </div>
</template>
